import type React from "react";
import { useMemo } from "react";
import { getRandomLoadingPhrase } from "../../utils/loadingPhrases";
import { Text } from "../Text";
import styles from "./LoadingSpinner.module.scss";

interface LoadingSpinnerProps {
  message?: string;
  useRandomPhrase?: boolean;
  fullscreen?: boolean;
  t?: (key: string, options?: { returnObjects?: boolean }) => string | string[];
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message,
  useRandomPhrase = true,
  fullscreen = true,
  t,
}) => {
  const displayMessage = useMemo(() => {
    if (message) return message;
    if (useRandomPhrase) return getRandomLoadingPhrase(t);
    return undefined;
  }, [message, useRandomPhrase, t]);

  return (
    <div className={fullscreen ? styles.fullscreen : styles.container}>
      <div className={styles.spinner} />
      {displayMessage && (
        <Text variant="medium" className={styles.message}>
          {displayMessage}
        </Text>
      )}
    </div>
  );
};
